import validate from "/home/zebrafashion/zebrafashion.com/releases/75947690/node_modules/nuxt/dist/pages/runtime/validate.js";
import reset_45category_45global from "/home/zebrafashion/zebrafashion.com/releases/75947690/middleware/reset-category.global.ts";
import manifest_45route_45rule from "/home/zebrafashion/zebrafashion.com/releases/75947690/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  reset_45category_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}